<style>
.v-input--checkbox {
  padding-top: 10px;
}
</style>
<template>
<div>
  <v-tooltip bottom v-if="card.isOneTimeCard === false && !card.blocked && card.canCharge">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" v-on="on" @click.native.stop="chargeDialog = true, selectedCard = card">
        <v-icon color="primary" class="fa fa-credit-card"></v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Dobít kredit') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-if="card.canActivate">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" @click="unblockCard(card)" v-on="on">
        <v-icon color="primary" class="fa fa-thumbs-up"></v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Aktivovat') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-if="card.canBlock">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" @click.native.stop="blockDialog = true, selectedCard = card" v-on="on">
        <v-icon color="primary" class="fa fa-thumbs-down"></v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Zablokovat') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-if="card.canMakeElectronicCopy && !hasEticket(card)">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" @click.native.stop="eCard(card)" v-on="on">
        <v-icon color="primary" class="fa fa-ticket-alt"></v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Vyrobit novou e-kartu') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-if="filteredExtraRates(card).length > 0 || filteredRatesToBuy(card).length > 0">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" @click.native.stop="ratesDialog = true" v-on="on">
        <v-icon color="primary" class="fa fa-cogs"></v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Služby') }}</span>
  </v-tooltip>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" @click.native.stop="aliasDialog = true" v-on="on">
        <v-icon color="primary">edit</v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Označení karty') }}</span>
  </v-tooltip>
  <v-dialog v-model="chargeDialog" max-width="300px">
    <v-card class="background: secondary">
      <v-card-text>
        <v-col pt-3>
          <select-charge v-model="chargedAmount"></select-charge>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click.native="chargeDialog=false">{{ $t('Zpět') }}</v-btn>
        <v-btn text color="primary" @click="chargeCredit(card, chargedAmount)" @click.native="chargeDialog=false">{{ $t('Dobít') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="blockDialog" max-width="300px">
    <v-card class="mt-1 background: secondary">
      <v-card-title>
        <div>{{ $t('Zablokovat kartu?') }}</div>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click.native="blockDialog=false">{{ $t('Zpět') }}</v-btn>
        <v-btn text color="primary" @click="blockCard(card)" @click.native="blockDialog=false">{{ $t('Zablokovat') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="ratesDialog" max-width="600px">
    <v-card v-if="filteredExtraRates(card).length > 0" class="mt-1 background: secondary">
      <v-card-title class="body-2 primary--text">
        <v-col class="text-center">{{ $t('Moje služby') }}</v-col>
      </v-card-title>
      <v-data-table :headers="extraHeaders" :items="filteredExtraRates(card)" hide-default-footer>
        <template v-slot:item.validTo="{ item }">{{ item.validTo | moment('D.M.Y') }}</template>
      </v-data-table>
    </v-card>
    <v-card v-if="filteredRatesToBuy(card).length > 0" class="mt-1 background: secondary">
      <v-card-title class="body-2 primary--text background: secondary">
        <v-col class="text-center">{{ $t('Služby k dokoupení') }}</v-col>
      </v-card-title>
      <v-data-table v-model="selectedRates" item-key="rateId" :headers="buyHeaders" :items="filteredRatesToBuy(card)" hide-default-footer show-select>
        <template v-slot:item.priceToBuy="{ item }">{{ item.priceToBuy | currency }}</template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-col xs="12" class="text-left">
          <v-btn text color="primary" @click.native="ratesDialog = false" @click="ratesToBasket()" :disabled="selectedRates.length === 0">{{ $t('Do košíku') }}</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="aliasDialog" max-width="400px">
    <v-card class="pt-3 background: secondary">
      <v-card-text>
        <v-text-field solo flat counter=64 :hint="$t('Označení karty')" persistent-hint v-model="card.aliasName"></v-text-field>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click.native="aliasDialog=false">{{ $t('Zpět') }}</v-btn>
        <v-btn text color="primary" @click="setAliasName(card.aliasName)" @click.native="aliasDialog=false" :disabled="card.aliasName===card.displayedCardNo">{{ $t('Nastavit') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import SelectCharge from '@/components/select-charge.vue'
const moment = require('moment')

export default {
  props: {
    card: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  mixins: [BasketMixin],
  components: {
    'select-charge': SelectCharge
  },
  data() {
    return {
      expanded: [],
      extraHeaders: [{
          text: 'Název',
          value: 'rate.name'
        },
        {
          text: 'Platnost',
          value: 'validTo',
          align: 'right',
          sortable: false
        },
        {
          text: 'Průchodů',
          value: 'entryCount',
          sortable: false
        },
        {
          text: 'Kurz',
          value: 'reservartion.name',
          sortable: false
        }
      ],
      buyHeaders: [{
          text: 'Název',
          value: 'name'
        },
        {
          text: 'Provoz',
          value: 'establishment.establishmentName',
          sortable: false
        },
        {
          text: 'Cena',
          value: 'priceToBuy',
          align: 'right',
          sortable: false,
          width: '140px'
        }
      ],
      chargeDialog: false,
      blockDialog: false,
      ratesDialog: false,
      aliasDialog: false,
      chargedAmount: 0,
      selectedRates: []
    }
  },
  computed: {},
  methods: {
    hasEticket(card) {
      return this.basketItems.some(i => i.itemType === 'ecard' && i.itemDesc.includes(card.displayedCardNo))
    },
    blockCard(card) {
      this.$fetch('my/cards/' + card.cardId + '/block', {
        method: 'PUT'
      }).then(data => {
        this.replaceCard(data)
      }).catch(() => console.log('card block error'))
    },
    unblockCard(card) {
      this.$fetch('my/cards/' + card.cardId + '/unblock', {
        method: 'PUT'
      }).then(data => {
        this.replaceCard(data)
      }).catch(() => console.log('card unblock error'))
    },
    chargeCredit(card, amount) {
      this.chargeCard(card, amount)
    },
    eCard(card) {
      this.putECard(card)
    },
    replaceCard(value) {
      if (value !== undefined && value !== null) {
        var array = []
        for (let i = 0; i < this.cards.length; i++) {
          if (this.cards[i].cardId === value.cardId) {
            array.push(value)
          } else {
            array.push(this.cards[i])
          }
        }
        this.cards = array
      }
    },
    isPast(value) {
      return moment().diff(value.validTo) > 0
    },
    filteredExtraRates(value) {
      return value.extraRates ? value.extraRates.filter(r => !this.isPast(r) && (r.entryCount === null || r.entryCount > 0)) : []
    },
    filteredRatesToBuy(value) {
      return value.ratesToBuy ? value.ratesToBuy.filter(r => !this.hasBasket(value, r)) : []
    },
    ratesToBasket() {
      if (this.selectedRates.length > 0) {
        this.putRates(this.selectedRates.map(r => ({
          rateId: r.rateId,
          cardId: this.card.cardId
        })))
        this.selectedRates = []
      }
    },
    hasBasket(card, rate) {
      return this.rateItems.find(r => !!rate && rate.rateId === r.rateItem.rateId && card.cardId === r.rateItem.cardId)
    },
    setAliasName(value) {
      var myData = {
        cardId: this.card.cardId,
        aliasName: value
      }
      this.$fetch('my/cards/' + this.card.cardId, {
        method: 'PUT',
        body: JSON.stringify(myData)
      }).then(data => {
        this.card.displayedCardNo = data.displayedCardNo
      }).catch(console.log)
    }
  },
  watch: {
    // selectedRates(value) {
    // console.log(value)
    // }
  }
}
</script>
